export const USER_SEARCH_DEFAULT_SORT = {
  sortedColumn: 'fullName',
  sortedColumnOrder: 'descend'
}
